import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

export const insightsTabStyle = css`
    > ul {
        overflow-x: auto;
        border-bottom: 1px solid ${Colors.Gray.V150};
    }

    ul > li {
        padding: 15px 24px;

        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        color: ${Colors.Black.V50};
        text-align: center;
        white-space: nowrap;

        outline: none;
    }
`;

export const tabSelectedClassName = css`
    color: ${Colors.Black.V200} !important;
`;

export const TabContent = styled.div`
    padding-top: 24px;
`;

export const LensInsightsPageContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 0;
`;

export const ChartPaper = styled.div<{ padding?: string; flexDirection?: string; margin?: string }>`
    display: flex;
    flex-direction: ${({ flexDirection }) => flexDirection ?? "row"};

    margin: ${({ margin }) => margin ?? "0"};
    padding: ${({ padding }) => padding ?? "16px 24px"};

    background: ${Colors.WHITE};
    border-radius: 6px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 14%);
`;
